import React from 'react';
import { History, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const RecentSearchesCard = ({ history, onPick }) => {
  if (!history?.length) return null;
  return (
    <Card data-testid="recent-searches-card">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <History size={18} className="text-purple-600" />
          Recent Searches
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {history.map((entry) => (
          <div
            key={entry.id || entry.symbol}
            className="flex items-center justify-between p-2 bg-gray-50 rounded hover:bg-gray-100 cursor-pointer transition-colors"
            onClick={() => onPick(entry.symbol)}
            data-testid={`recent-row-${entry.symbol}`}
          >
            <div className="flex items-center gap-2">
              <Clock size={14} className="text-gray-400" />
              <span className="font-medium text-sm">{entry.symbol}</span>
            </div>
            <span className={`text-xs ${entry.changePercent >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {entry.changePercent >= 0 ? '+' : ''}{entry.changePercent?.toFixed(2)}%
            </span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default RecentSearchesCard;
